import React from 'react';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import styles from './styles';

const getDefaultRenderOptionFn = (disabled, classes) => (option) => (
  <FormControlLabel
    key={option.id}
    value={option.id}
    control={
      <Radio
        classes={{ root: classes.radio }}
        disabled={disabled}
      />
    }
    label={<Typography className={classes.radioLabel}>{option.name}</Typography>}
  />);

export default function FormRadioGroup(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const {
    id,
    name,
    data,
    disabled,
    radioGroupClasses,
    renderOption,
    selected,
    tooltip,
    onChange,
  } = props;

  return (
    <FormControl
      component="fieldset"
      className={classes.formControl}
      id={id}
      data-apim-test={id}
      data-layer7-test={id}
    >
      {name &&
        <FormLabel
          component="h3"
          className={classes.formLabel}
        >
          <span>{name}</span>
          {tooltip &&
            <Tooltip placement="right" title={tooltip}>
              <HelpIcon className={classes.helpIcon} />
            </Tooltip>
          }
        </FormLabel>
      }
      <RadioGroup
        classes={radioGroupClasses}
        value={selected}
        onChange={(e) => { onChange(get(e, 'target.value')); }}
        name={name}
      >
        {data.map(renderOption || getDefaultRenderOptionFn(disabled, classes))}
      </RadioGroup>
    </FormControl>
  );
}

FormRadioGroup.propTypes = {
  selected: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  radioGroupClasses: PropTypes.shape({}),
  tooltip: PropTypes.string,
  renderOption: PropTypes.func,
};
